import { assembleUrl } from '@/utils/url'

export default class ProgramsService {
  constructor($axios, $store) {
    this.axios = $axios
    this.school = $store.state.settings.school
    this.activeCatalog = $store.state.settings.activeCatalog
    this.effectiveDatesRange =
      $store.getters['settings/effectiveDatesRangeAsString']
    this.programsUrl = `/cm/${this.school}/programs`

    this.programsFilters = $store.state.settings.programsFilters
    this.hasFilters =
      this.programsFilters?.filters && this.programsFilters?.filters.length > 0

    this.filters = this.hasFilters
      ? {
          ...this.programsFilters,
          filters: this.programsFilters.filters,
        }
      : {}

    this.departmentProgramsGroupingField = $store.state.departments?.pageLayoutSettings
      ?.find((setting) => setting.id === 'programs' && setting.enabled)?.grouping?.field || ''
  }

  getColumns(columnsStrOrArr) {
    const columns = Array.isArray(columnsStrOrArr) ? columnsStrOrArr : [ columnsStrOrArr ]
    const columnsSet = new Set([ ...columns, this.departmentProgramsGroupingField ])
    return [ ...columnsSet ].filter(Boolean)
  }

  getPrograms({
    query = '$filters',
    skip = 0,
    limit = 50000,
    filters = this.filters,
    columns = [],
    department,
    sortBy,
    programGroupIds,
  }) {
    const skipParam = encodeURIComponent(skip)
    const queryParam = encodeURIComponent(query)
    const limitParam = encodeURIComponent(limit)
    const normalizedColumns = this.getColumns(columns)
    let url = assembleUrl(`${this.programsUrl}/search/${queryParam}`, {
      catalogId: this.activeCatalog,
      skip: skipParam,
      limit: limitParam,
      sortBy,
      effectiveDatesRange: this.effectiveDatesRange,
      ...(normalizedColumns?.length ? { columns: normalizedColumns.join(',') } : {}),
    })
    if (department) url += `&departments=${department}`
    return this.axios.$post(url, {
      ...filters,
      ...(programGroupIds ? { programGroupIds } : {}),
    })
  }

  getProgram(programGroupId, {includeMappedDocumentItems = false, effectiveDatesRange = '', columns = ''} = {}) {
    const normalizedColumns = this.getColumns(columns)
    const url = assembleUrl(this.programsUrl, {
      programGroupIds: programGroupId,
      effectiveDatesRange: this.effectiveDatesRange,
      doNotDisplayAllMappedRevisionsAsDependencies: true,
      formatDependents: true,
      includeMappedDocumentItems,
      ...(normalizedColumns?.length ? { columns: normalizedColumns.join(',') } : {}),
      ...(effectiveDatesRange ? { effectiveDatesRange } : {}),
    })
    return this.axios.$get(url).then((data) => Object.values(data)[0])
  }
}
